import { useEffect, useState, memo } from "react";
import { Marker, InfoWindow } from "@react-google-maps/api";

interface ProblemLocationMarkerProps {
  position: { lat: number; lng: number };
  onAddressResolved?: (address: string) => void;
}

export const ProblemLocationMarker = memo(
  ({ position, onAddressResolved }: ProblemLocationMarkerProps) => {
    const [address, setAddress] = useState<string>("Obtendo endereço...");

    useEffect(() => {
      // Verificar se o Google Maps está carregado
      if (typeof google === "undefined" || !google.maps) {
        console.log("Google Maps ainda não carregado");
        return;
      }

      // Geocoding reverso para obter o endereço
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: position }, (results, status) => {
        if (status === "OK" && results && results[0]) {
          const fullAddress = results[0].formatted_address;
          // Extrair rua e número para exibição no mapa
          const parts = fullAddress.split(",");
          const streetAddress = parts.slice(0, 2).join(",").trim();
          setAddress(streetAddress);
          // Passar endereço completo para o componente pai
          onAddressResolved?.(fullAddress);
        } else {
          console.error("Erro no geocoding:", status);
          setAddress("Endereço não encontrado");
        }
      });
    }, [position]);

    // SVG customizado para o marcador (pin azul institucional)
    const icon = {
      path: "M12 0C7.31 0 3.5 3.81 3.5 8.5c0 7.13 8.5 15.5 8.5 15.5s8.5-8.37 8.5-15.5C20.5 3.81 16.69 0 12 0zm0 11.5c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z",
      fillColor: "hsl(211 75% 30%)",
      fillOpacity: 1,
      strokeWeight: 0,
      scale: 2,
      anchor: new google.maps.Point(12, 24),
    };

    return (
      <>
        <Marker position={position} icon={icon} />
        <InfoWindow
          position={position}
          options={{
            pixelOffset: new google.maps.Size(0, -48),
            disableAutoPan: true,
            maxWidth: 220,
          }}
        >
          <div
            style={{
              fontSize: "12px",
              color: "#111827",
              fontWeight: 500,
              whiteSpace: "normal",
              wordWrap: "break-word",
              margin: 0,
              padding: 0,
              overflow: "hidden",
              maxWidth: "100%",
              textAlign: "center",
              lineHeight: "1.2",
              minHeight: "auto",
              height: "auto",
            }}
          >
            {address}
          </div>
        </InfoWindow>
      </>
    );
  },
);
